import classes from '../index.module.scss';
import React, { useContext } from 'react';
import { SearchContext } from '../../../context/Search';
import { HashLink } from 'react-router-hash-link';
import { UserContext } from '../../../context/User';

const FutureOpportunitiesTableBody = () => {
  const { searchedData } = useContext(SearchContext);
  const { isLoggedIn } = useContext(UserContext);

  return (
    <>
      {
        searchedData.map(item => {
          const { title, id, naics, agency } = item;

          return (
            <tr 
              key={id}
            >
              <td>
                <p className={classes.Title_Bold}>
                  <HashLink
                    to={isLoggedIn ? `/future?id=${id}` : '/#basic-info'}
                    smooth
                  >
                    {title || "-"}
                  </HashLink>
                </p>
                <p className={classes.Title_Light}>NAICS: {naics}</p>
              </td>
              <td  className={`${classes.No_Wrap} ${classes.Title_Normal}`}>Future Opportinities</td>
              <td className={`${classes.No_Wrap} ${classes.Title_Normal}`}>{agency || "-"}</td>
            </tr>
          )
        })
      }
    </>
  )
}

export default FutureOpportunitiesTableBody;